import { CHANGE_SEARCH_BY } from "./actionTypes";

export default ({searchBy, objectType}) => ({
  type: CHANGE_SEARCH_BY,
  payload: {
    objectType, 
    searchBy
  }
});